'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useEffect, useRef, useState } from 'react';

import cx from 'classnames';
import { usePathname } from 'next/navigation';
import PropTypes from 'prop-types';

import ButtonCircle from 'components/ui/ButtonCircle';
import Icon from 'components/ui/Icon';
import EntryLink from 'components/ui/Link/EntryLink';
import Text from 'components/ui/Text';

import useScrollDirection from 'hooks/useScrollDirection';

import styles from './CommitmentSubNav.module.scss';

const CommitmentSubNav = ({ currentPage, idx, pages }) => {
    const [isExpanded, toggleExpanded] = useState(false);
    const scrollDirection = useScrollDirection();
    const ref = useRef(null);
    const pathname = usePathname();

    const updateExpanded = () => {
        toggleExpanded(!isExpanded);
    };

    function handleOutsideClick(event) {
        if (ref?.current && !ref?.current.contains(event.target)) {
            toggleExpanded(false);
        }
    }

    function toggleEventListener(method) {
        document[`${method}EventListener`]('click', handleOutsideClick);
    }

    useEffect(() => {
        if (scrollDirection === 'down') {
            isExpanded && toggleExpanded(false);
        }
    }, [isExpanded, scrollDirection]);

    useEffect(() => {
        toggleEventListener('add');

        return () => {
            toggleEventListener('remove');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        isExpanded && toggleExpanded(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return (
        <header
            ref={ref}
            className={cx(styles.commitmentNavContainer, {
                [styles.isHidden]: scrollDirection === 'down',
            })}
        >
            <div
                className={cx(
                    styles.commitmentNav,
                    isExpanded && styles.isExpanded
                )}
            >
                <button
                    type="button"
                    className={cx(
                        styles.currentPage,
                        isExpanded && styles.shrink
                    )}
                    onClick={updateExpanded}
                    aria-expanded={isExpanded}
                >
                    <Text baseTheme="headingXSmall">{currentPage?.title}</Text>
                    <ButtonCircle
                        as="span"
                        aria-hidden="true"
                        className={cx(
                            styles.buttonCircle,
                            isExpanded && styles.flip
                        )}
                        theme="small-fill-creamdark"
                        iconType="chevronDown"
                    >
                        <span />
                    </ButtonCircle>
                </button>
                <nav
                    className={cx(styles.nav, isExpanded && styles.isExpanded)}
                >
                    <ul className={styles.pageList}>
                        {pages.map((page, idx) => (
                            <li key={idx}>
                                <EntryLink entry={page}>
                                    <div className={styles.page}>
                                        <div className={styles.iconBox}>
                                            <div
                                                className={cx(
                                                    styles.commitmentIconWrapper
                                                )}
                                            >
                                                <Icon
                                                    src={page?.icon?.icon?.url}
                                                />
                                            </div>
                                        </div>
                                        <div className={styles.pageLabel}>
                                            <Text baseTheme="headingXSmall">
                                                {page.title}
                                            </Text>
                                        </div>
                                        <ButtonCircle
                                            as="span"
                                            aria-hidden="true"
                                            className={styles.pageArrow}
                                            theme="small-fill-creamdark"
                                            iconType="chevronRight"
                                        >
                                            <span />
                                        </ButtonCircle>
                                    </div>
                                </EntryLink>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </header>
    );
};

CommitmentSubNav.propTypes = {
    pages: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
        }).isRequired
    ),
    currentPage: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        idx: PropTypes.number,
    }).isRequired,
    idx: PropTypes.number,
};

export default CommitmentSubNav;
